import React from 'react'

import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { Layout, Menu } from 'antd'

import 'antd/dist/antd.css'

import Home from './Home'
import TransformEditor from './TransformEditor'
import IngestForm from './IngestForm'

const { Header, Content, Footer } = Layout

class App extends React.Component {
  render() {
    return (
      <Router>
        <Layout>
          <Header>
            <Menu theme="dark" mode="horizontal">
              <Menu.Item key="1"><Link to="/">STOP Demo</Link></Menu.Item>
              <Menu.Item key="2"><Link to="/ingest">Enter STOP Data</Link></Menu.Item>
            </Menu>
          </Header>
          <Content style={{ padding: '2vh 5vw' }}>
            <Route exact path="/" component={Home} />
            <Route path="/transform/:id" component={TransformEditor} />
            <Route path="/ingest" component={IngestForm} />
          </Content>
          <Footer>
          </Footer>
        </Layout>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js